var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isExpired)?_c('div',{staticClass:"text-muted"},[_c('small',[_vm._v("Offer will expire in")]),_vm._v(" "+_vm._s(_vm.timeLeft)+" ")]):_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Offer expired")])])}
var staticRenderFns = []

export { render, staticRenderFns }